
import { Box, Typography } from '@mui/material';
import React from 'react'
import Slider from 'react-slick';

const BannerSlider = ({ Sliders }) => {
    const sliderSettings = {
        dots: false,
        infinite: true,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
              },
            },
          ],
    };
    return (
        <Slider {...sliderSettings}>
            {Sliders.map((slider, index) => (
                <Box key={index} sx={{ display: 'flex !important', paddingTop:'20px', paddingLeft:'10px', flexDirection: 'column', width: '100%' }}>
                    <Box sx={{
                      width: { xs:'95%', md: '70%', lg: '90%', xl: '95%'},
                    }}>
                      <img
                          src={slider?.src}
                          alt={`Slide ${index + 1}`}
                          style={{
                              width: '100%',
                              borderRadius: '25px',
                              boxShadow: '0px 7px 7px rgba(0, 0, 0, 0.2)',
                              zIndex: 1,
                          }}
                      />
                    </Box>
                    <Typography
                        variant="body1"
                        sx={{ mt: 3, fontSize: '13px', textAlign: 'left', width: { xs: '100%', sm: '80%', md: '80%', lg: '60%' }}}
                    >
                        {slider?.tagline}
                    </Typography>
                </Box>
            ))}
        </Slider>
    )
}

export default BannerSlider